import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SortHelper } from '@core/helpers/sort.helper';
import { CustomerDto } from '@interfaces/CustomerDto';
import { Estimate } from '@interfaces/Estimate';
import { Project } from '@interfaces/Project';
import { EstimateService } from '@shared/services/estimate.service';
import { LoadingService } from '@shared/services/loading.service';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'pop-deploy-dialog',
  templateUrl: './deploy-dialog.component.html',
  styleUrls: ['./deploy-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class DeployDialogComponent implements OnInit {
  private currentEstimate: Estimate;
  public customers: CustomerDto[] = [];
  public form = this.formBuilder.group({
    projectCode: ['', Validators.required],
    projectClientCode: ['', Validators.required],
    isUsingPC: [false]
  });
  private isUsingPC = false;
  private projectCodes: Project[];

  public constructor(
    public dialogRef: MatDialogRef<DeployDialogComponent>,
    private estimateService: EstimateService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { estimateId: string }
  ) {}

  public async ngOnInit() {
    await this.loadingService.run(async () => {
      this.currentEstimate =
        this.estimateService.currentEstimate ??
        (await firstValueFrom(this.estimateService.getEstimateById(this.data.estimateId).pipe(take(1))));

      if (this.currentEstimate.projectCode) {
        this.form.get('projectCode').setValue(this.currentEstimate.projectCode);
      }

      if (this.currentEstimate.clientCode) {
        this.form.get('projectClientCode').setValue(this.currentEstimate.clientCode);
      }

      if (this.currentEstimate.companyCode != null) {
        this.projectCodes = await firstValueFrom(this.estimateService.getProjects());
        SortHelper.sortArrayByCode(this.projectCodes);
      }

      this.customers = await firstValueFrom(
        this.estimateService.getCustomerByCompany(this.currentEstimate.companyCode)
      );

      //CustomerName without clientCode
      if (this.currentEstimate.clientName) {
        const customer = this.customers.find(c => c.customerName == this.currentEstimate.clientName);
        if (customer.customerId) this.form.get('projectClientCode').setValue(customer.customerId);
      }

      SortHelper.sortArrayByProperty(this.customers, o => o.customerName);
    });
  }

  public onSelectProjectClientCode() {
    const clientCode = this.form.get('projectClientCode').value;

    if (!this.currentEstimate.clientName) {
      const clientName = this.customers.find(x => x.customerId == clientCode).customerName;
      if (clientName != null) this.currentEstimate.clientName = clientName;
    }
  }

  public async deployEstimate() {
    await this.loadingService.run(async () => {
      this.isUsingPC = this.form.get('isUsingPC').value;

      if (this.estimateService.entityManagerHasChanges()) {
        await this.estimateService.saveChangesAsync();
      }

      await this.estimateService.deployEstimate(this.isUsingPC);
      await this.estimateService.refreshEstimateAsync(this.currentEstimate);

      this.dialogRef.close(true);
    });
  }

  public onNoClick(): void {
    this.dialogRef.close(false);
  }
}
